import React from 'react'
import classes from "./NewActualDesign.module.scss"
import { CartButtonSelectedSvg, CartButtonSvg, CircleTickSvg, CountryFlagSvg } from '../../constants/resources'
import { ItineraryInsurance } from '../../atom/Types'


interface props {
    handleInsurance: (node: ItineraryInsurance, index: number) => void;
    singleNode: ItineraryInsurance;
    ind: number;
}


const InsuranceSlider: React.FC<props> = ({ handleInsurance, ind, singleNode }) => {

    console.log(singleNode, 'singleNode');

    return (
        <div className={classes.insContainer} onClick={() => handleInsurance(singleNode, ind)}>
            <div className={classes.insHead}>
                <p className={classes.insProvider}>{singleNode.insurance.provider}</p>
                <p className={classes.insType}>F{singleNode.insurance.plan}
                </p>
            </div>
            <div className={classes.insContent}>
                <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CountryFlagSvg />{singleNode.insurance.state}</button>
            </div>
            <hr />
            <div className={classes.insBottom}>
                <div className={classes.insPrice}>
                    <p className={classes.insProvider}>Total Price</p>
                    <p className={classes.insType} style={{ color: '#0279CF' }}>${singleNode.publishedPrice}</p>
                </div>
                {singleNode.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}

            </div>
        </div>
    )
}

export default InsuranceSlider